<template>
  <div>
    <RequestModal v-if="showRequestModal" v-on:closeModal="showRequestModal = false"/>
    <MessageModal v-if="showMessageModal" v-on:closeModal="showMessageModal = false" />
    <section class="bgrdimg">
      <Nav />
      <div class="relative stars">
        <img src="../assets/img/about/Group 280.svg" alt="">
        <img src="../assets/img/contact/Group 359.svg" alt="" class="svg hidden lg:inline-block svgleft" >
        <img src="../assets/img/contact/Group 360.svg" alt="" class="svg svgright hidden lg:inline-block">
      </div>
      
      <div class="px-4 pb-24 contactbox">
        <div class="w-3/4 lg:text-center lg:w-full">
          <h1 class="text-3xl font-bold text-white lg:text-4xl">What can we do for you today?</h1>
          <p class="mt-4 text-lg font-light text-blue-500">Get in touch and let us know how we can help</p>
        </div>
        <div class="rounded-md mt-8 bg-white px-4 py-2 lg:w-1/2 lg:px-8 lg:mx-auto flex justify-between items-center inputdiv">
          <input class="bg-white inline outline-none w-full" type="text" placeholder="have a question you would like to resolve">
          <font-awesome-icon icon="search" class="" />
        </div>
      </div>
    </section>
    <section class="bg-white px-6 lg:px-20 py-8 lg:pt-24">
      <p style="color: #062648" class="text-light">Frequently Asked Questions 
        <font-awesome-icon icon="question-circle" class="ml-4" />
      </p>
      <hr class="mt-6">
      <ul class="questionlist lg:flex lg:justify-between lg:gap-20 mt-12">
        <li style="color: #062648">
          <p class="font-bold text-lg">How to Implement eTranazact for my business?</p>
          <div class="mt-4">
            <p class="text-blue-500">Get Help</p>
          </div>
        </li>
        <li style="color: #062648" class="mt-8 lg:mt-0">
          <p class="font-bold text-lg">How do I accept payment for my personal use?</p>
          <div class="mt-4">
            <p class="text-blue-500">Get Help</p>
          </div>
        </li>
        <li style="color: #062648" class="mt-8 lg:mt-0">
          <p class="font-bold text-lg">How to setup my account and add my payment method?</p>
          <div class="mt-4">
            <p class="text-blue-500">Get Help</p>
          </div>
        </li>
      </ul>
    </section>
    <section class="mt-12 bg-white contactbox px-6 lg:px-20 py-8">
      <p class="text-blue-500 text-2xl font-bold">Our offices & contact information</p>
      <ul class="mt-4">
        <li class="lg:flex lg:justify-between lg:items-center">
          <div class="lg:w-full">
            <p class="mt-8 text-blue-500">Address</p>
            <p class="mt-4 text-gray-600">5th Floor Fortune Towers, 27/29 Adeyemo Alakija Street, Victoria Island, Lagos Nigeria.</p>
          </div>
          <div class="mt-8 lg:mt-0 lg:w-full">
            <p class=" text-blue-500">Telephone</p>
            <p class="mt-4 text-gray-600">017101060, 02092927336</p>
          </div>
          <div class="mt-8 lg:mt-0 lg:w-full">
            <p class="text-blue-500">Fax</p>
            <p class="mt-4 text-gray-600">017101060</p>
          </div>
        </li>
      </ul>
    </section>
    <section class="mt-12 px-6 lg:px-20 py-8">
      <ul class="lg:flex lg:justify-between lg:gap-20 complaintlist">
        <li class="">
          <p class="text-gray-600 font-bold">For complaints</p>
          <p class="mt-4 font-light text-gray-600">cic@eTranzact.com</p>
        </li>
        <li class="mt-12 lg:mt-0">
          <p class="text-gray-600 font-bold">Whatsapp line</p>
          <p class="mt-4 font-light text-gray-600">+2349087989094</p>
        </li>
        <li class="mt-12 lg:mt-0">
          <p class="mt-4 lg:mt-0 font-light text-gray-600">
            For all enquiries, contact us at info-<span class="text-blue-500">ng@etranzact.com</span> or <span class="text-blue-500">agentenquiries@eTranzact.com</span>
          </p>
          <p class="font-light text-gray-600">We’re open 24/7</p>
        </li>
        <li class="mt-12 lg:mt-0">
          <button class="text-white px-6 py-3 rounded-lg" style="background-color: #062648" @click="sendMail">Drop a message</button>
        </li>
      </ul>
    </section>
    <Subscribe />
    <Footer v-on:showRequest="showRequestModal = true"/>
  </div>
</template>

<script>
import Nav from "@/components/Nav"
import MessageModal from "@/components/MessageModal"
import RequestModal from "@/components/RequestModal"
import Footer from "@/components/Footer"
import Subscribe from "@/components/Subscribe"
export default {
  components:{
    Nav,
    MessageModal,
    RequestModal,
    Footer,
    Subscribe
  },
  data(){
    return {
      showMessageModal : false,
      showRequestModal: false,
    }
  },
  methods:{
    sendMail(){
      window.open('mailto:cic@etranzact.com');
    }
  }
}
</script>

<style scoped>
/* Modal Styling */
.l-modal{
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0, 0.3);
}
.loading-modal{
  min-height: 350px; 
}
/* Modal Styling */

section.bgrdimg{
  background-image: url('../assets/img/contact/Intersection 17.svg');
  background-size: cover;
  background-repeat: no-repeat;
}
.stars{
  top: -20px;
  overflow-x: hidden;
}
.svg{
  width: 300px;
  position: absolute
}
.svgleft{
  bottom: 90px;
  left: -50px
}
.svgright{
  right: -50px;
  bottom: 0
}
div.contactbox{
  margin-top: -20px
}
.inputdiv input::placeholder{
  font-size: 0.8em;
  font-style: italic;
}
.questionlist li{
  max-width: 75%
}
@media only screen and (min-width: 1024px){
  div.contactbox{
    margin-top: -150px
  }
  .questionlist li,.contactlist li{
    max-width: 25%
  }
 .complaintlist li{
   max-width: 20%
 }
}
</style>
